<template>
  <a-drawer width="45%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item :label="this.$t('上门服务分类.分类名称')" prop="categoryName" >
        <a-input v-model="form.categoryName" :maxLength="16"
                 :placeholder="$t('通用.输入.请输入')+this.$t('上门服务分类.分类名称')" />
      </a-form-model-item>

      <a-form-model-item :label="this.$t('上门服务分类.分类图标')" prop="icon">
        <OssUploadSingle v-model="form.icon" type="img" :maxSize="200" prefix="category"></OssUploadSingle>
        <span>推荐尺寸 60 x 60</span>
      </a-form-model-item>

      <a-form-model-item :label="$t('上门服务分类.是否首页展示')" prop="isHomeVisible" >
        <a-radio-group v-model="form.isHomeVisible" button-style="solid">
          <a-radio-button v-for="(item, index) in this.customDict.TFEnum" :value="item.type" :key="index">
            {{ item.name }}
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>

      <a-form-model-item :label="$t('通用.文本.排序')" prop="sort" >
        <a-input-number :maxLength="6" style="width: 50%"  @change="limitSort" v-model="form.sort"
                        :placeholder="$t('通用.输入.请输入')+$t('通用.文本.排序')" />
      </a-form-model-item>

      <a-form-model-item :label="this.$t('上门服务分类.备注')" prop="remark">
        <a-textarea v-model="form.remark" :rows="3" :maxLength="500" />
      </a-form-model-item>

      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('通用.按钮.保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('通用.按钮.取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getCategory, addCategory, updateCategory } from '@/api/homeservice/category'
import {mapGetters} from 'vuex'
import OssUploadSingle from "@/components/OssUploadSingle";

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    OssUploadSingle,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,
        parentId: 0,
        categoryName: null,
        categoryLevel: 1,
        icon: null,
        isHomeVisible: true,
        sort: 0,
        remark: null,
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        categoryName: [
          { required: true, message: this.$t('上门服务分类.分类名称')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        isHomeVisible: [
          { required: true, message:  this.$t('上门服务分类.是否首页展示')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        parentId: 0,
        categoryName: null,
        icon: null,
        categoryLevel: 1,
        isHomeVisible: true,
        sort: 0,
        remark: null,
      }
    },
    /** 新增按钮操作 */
    handleAdd (parentId) {
      this.reset()
      if (parentId) {
        // 添加子分类
        this.form.parentId = parentId
        this.form.categoryLevel = 2
        this.formTitle = this.$t('上门服务分类.新增二级分类')
      } else {
        // 添加一级分类
        this.form.parentId = 0
        this.form.categoryLevel = 1
        this.formTitle = this.$t('上门服务分类.新增一级分类')
      }
      this.form.isHomeVisible = true
      this.formType = 1
      this.open = true
    },
    /** 修改按钮操作 */
    handleUpdate (row) {
      this.reset()
      this.formType = 2
      const id = row.id
      getCategory({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('上门服务分类.修改分类')
      })
    },

    limitSort(sort) {
      console.log(sort)
      let val = sort;
      if(val==null||val==undefined||val==''||val<0){
        val=0
      }
      if (val > 999999) {
        val = 999999
      }
      this.form.sort = val
    },

    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateCategory(this.form).then(response => {
              this.$message.success(
                this.$t('通用.文本.修改成功'),
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addCategory(this.form).then(response => {
              this.$message.success(
                this.$t('通用.文本.新增成功'),
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
